import { Skeleton } from 'shared/ui/skeleton';
import { ResourceStatusSkeleton } from '@/enteties/project/ui/resource-status-skeleton';
import { InstanceControllerSkeleton } from 'widgets/instance-controller/ui/instance-controller-skeleton';
export const LoadingServicesItems = () => {
  return <div className="flex gap-2 flex-col" data-sentry-component="LoadingServicesItems" data-sentry-source-file="loading-services-items.tsx">
      {Array.from({
      length: 6
    }).map((_, index) => <div
    // eslint-disable-next-line react/no-array-index-key
    key={index} className="flex h-[68px] w-full items-center justify-between rounded-lg bg-accent px-6">
          <div className="flex items-center gap-6 pr-3">
            <Skeleton className="h-2 w-32  bg-background" />
          </div>
          <div className="flex gap-4 items-center">
            <ResourceStatusSkeleton />
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div className="hidden lg:flex">
              <InstanceControllerSkeleton variant="default" />
            </div>
          </div>
        </div>)}
    </div>;
};